import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Menu } from 'antd';

const linkMap = {
  epr: '/workflow/expense-payment-request',
};

function Navigation() {
  const history = useHistory();
  const [state, setState] = useState({ selected: null });

  const onClick = (e) => {
    setState((curr) => ({ ...curr, selected: e.key }));
    // Redirect
    if (history.location.pathname !== linkMap[e.key]) {
      history.push(linkMap[e.key]);
    }
  };

  return (
    <Menu
      theme="dark"
      mode="horizontal"
      selectedKeys={[state.selected]}
    >
      <Menu.SubMenu key="forms" title="Forms">
        <Menu.Item key="epr" onClick={onClick}>
          Expense Payment request
        </Menu.Item>
      </Menu.SubMenu>
    </Menu>
  );
}

export default Navigation;
